import Template from '../../component/Template';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import React, { useRef } from "react";
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';


export default function Coursemapping() {// CHECKING IF USER IS VALID
    const [message, setMessage] = useState(false);
    const [discipline, setDisciplineData] = useState([]);
    const [colleges, setCollegeData] = useState([]);  //05/04/2024 
    const [pathway, setPathway] = useState(false);
    const [pathwaylist, setPathwayList] = useState([]);
    const [value, setValue] = useState(false)
    const [selceted, setSelctedoption] = useState(false)
    const [discselceted, setdSelctediscoption] = useState(false)
    const [selecteddiscipline, setSelectedDisciplineData] = useState([]);


    let SlNo = 1;
    const { http } = Api();

    const [tabRows, setTabRows] = useState({
        tab1: [{ id: 1 }],
        tab2: [{ id: 1 }],
        tab3: [{ id: 1 }],
        tab4: [{ id: 1 }],
        tab5: [{ id: 1 }],
        tab6: [{ id: 1 }],
        tab7: [{ id: 1 }],
        tab8: [{ id: 1 }]
    });



    const getCoursesByFacultyAndDiscipline = async (disciplineId, pathwayid, collegeid) => {
        try {
            setMessage(false);
            const queryParams = new URLSearchParams({
                pathway_id: pathwayid,
                discipline_id: disciplineId,
                college_id: collegeid
            });

            const url = `/Admin/getpathwaystructure?${queryParams}`;
            const response = await http.get(url);
            console.log(response);

            // Update pathway state
            setPathway(`${response.data[0].pathway_name} - ${response.data[0].pathway_description}`);

            // Update tab rows
            const coursesBySemester = {};
            response.data.forEach(course => {
                if (!coursesBySemester[course.semester_id]) {
                    coursesBySemester[course.semester_id] = [];
                }
                coursesBySemester[course.semester_id].push(course);
            });

            setTabRows({
                tab1: coursesBySemester[1] || [],
                tab2: coursesBySemester[2] || [],
                tab3: coursesBySemester[3] || [],
                tab4: coursesBySemester[4] || [],
                tab5: coursesBySemester[5] || [],
                tab6: coursesBySemester[6] || [],
                tab7: coursesBySemester[7] || [],
                tab8: coursesBySemester[8] || [],
            });
        } catch (error) {
            setMessage("Something went wrong");
            console.error('Error fetching course data:', error);
        }
    };


    const handleFacultyAndDisciplineChange = (selectedOption) => {


        const collegeId = localStorage.getItem("collegeid");
        const disciplineId = selecteddiscipline;       
        const pathwayId = document.getElementById("pathwayid").value;

        console.log(collegeId, disciplineId, pathwayId);

        getCoursesByFacultyAndDiscipline(disciplineId, pathwayId, collegeId);
    };


    const PathwayChange = (selectedOption) => {


        const disciplineId = selecteddiscipline; 
        const collegeId = localStorage.getItem("collegeid");  
        const pathwayId = document.getElementById("pathwayid").value;
           
        console.log(collegeId, disciplineId, pathwayId);

        getCoursesByFacultyAndDiscipline(disciplineId, pathwayId, collegeId);
    };


const handleDisciplineChange = (selectedOption) => {

        setSelectedDisciplineData(selectedOption.value); 
      
        const disciplineId = selectedOption.value; 
        
        const pathwayid = document.getElementById("pathwayid").value;     
        const collegeId = localStorage.getItem("collegeid");   
        
        getCoursesByFacultyAndDiscipline(disciplineId, pathwayid,collegeId);
    };
    

    const Row = ({ rows, tab }) => (
        <>
            {/* Column Headings */}
            <div className="row g-3 pdg3 txt-aln" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                <div className="col-md-1">Paper Id</div>
                <div className="col-md-3">Course component structure code</div>
                <div className="col-md-6">Course title</div>
                <div className="col-md-2">Credit</div>
            </div>
            {/* Rows */}
            {rows.map((row, index) => (
                row.is_minor === "Y" && row.minors && Object.keys(row.minors).length > 0 ? (
                    <div className="box2 bx1" style={{ margin: "15px 8px", padding: "0px 6px" }} key={index}>
                        {Object.keys(row.minors).map((minorId, minorIndex) => {

                            return (
                                <div key={minorIndex}>
                                    {Object.keys(row.minors[minorId]).map((minorName) => {
                                        return row.course_discipline_component_code.split(',').map((code, index) => (
                                            <div key={index + minorIndex} className="row">
                                                {index === 0 && (
                                                    <label className="pdg8"><b>Minor {minorIndex + 1} : {minorName} </b></label>
                                                )}

                                                <div className="col-md-1">
                                                    <input type="text" className="form-control " placeholder="Code" value={row.paper_id}></input>
                                                </div>
                                                <div className="col-md-3">
                                                    <select className="form-control" value={code.trim()}>
                                                        <option value={code.trim()}>{code.trim()}</option>
                                                    </select>
                                                </div>
                                                {code.trim() == "DSCB" && (
                                                    <div className="col-md-6 txt-aln">
                                                        <select className="form-control form-select" readOnly>
                                                            {row.minors[minorId][minorName]
                                                                .filter(course => course.course_curriculum_structure_component_id === 6)
                                                                .map((course, index) => (
                                                                    <option key={index} value={course.course_name}>{course.course_name}</option>
                                                                ))
                                                            }
                                                        </select>
                                                    </div>
                                                )}

                                                {code.trim() == "DSCC" && (
                                                    <div className="col-md-6 txt-aln">
                                                        <select className="form-control form-select" readOnly>
                                                            {row.minors[minorId][minorName]
                                                                .filter(course => course.course_curriculum_structure_component_id === 7)
                                                                .map((course, index) => (
                                                                    <option key={index} value={course.course_name}>{course.course_name}</option>
                                                                ))
                                                            }
                                                        </select>
                                                    </div>
                                                )}

                                                <div className="col-md-2">
                                                    <input type="number" className="form-control" id="credit" name="credit" placeholder="Credit" value={row.credit}></input>
                                                </div>
                                            </div>
                                        ));
                                    })}
                                </div>
                            )
                        })}
                    </div>
                ) : (
                    <div className="row g-3" key={index} style={{ marginTop: '1px' }}>
                        <div className="col-md-1">
                            <input type="text" className="form-control" placeholder="Code" value={row.paper_id}></input>
                        </div>
                        <div className="col-md-3">
                            {row.course_discipline_component_code ? (
                                <select className="form-control " value={row.course_discipline_component_code}>
                                    {row.course_discipline_component_code.split(',').map((code, index) => (
                                        <option key={index} value={code.trim()}>{code.trim()}</option>
                                    ))}
                                </select>
                            ) : (
                                <input type="text" className="form-control" placeholder="Structure Code" />
                            )}


                        </div>
                        <div className="col-md-6">

                          
                            {row.is_elective === "Y" ? (

                                row.aec_course ?(
                                    <Select
                                    className="form-control "
                                    isMulti
                                    options={row.aec_course.map(course => ({
                                        value: course.course_id,
                                        label: course.course_name
                                    }))}
                                // value={selectedCourses} // selectedCourses is the state that holds the selected options
                                // onChange={handleCourseChange} // handleCourseChange is the function to handle changes in selected options
                                />
                                ):(
                                <Select
                                    className="form-control "
                                    isMulti
                                    options={row.elective_course.map(course => ({
                                        value: course.course_id,
                                        label: course.course_name
                                    }))}
                                // value={selectedCourses} // selectedCourses is the state that holds the selected options
                                // onChange={handleCourseChange} // handleCourseChange is the function to handle changes in selected options
                                />
                            )) : (
                                row.aec_course && row.aec_course.length>0 ?(


                                    <select className="form-control form-select" >
                                    {row.aec_course.map(course => (

                                        <option value={course.course_id}  >{course.course_name}</option>
                                    ))}
                                   </select>
                                   
                                ): row.elective_course && row.elective_course.length > 0 ? (

                                    <select className="form-control form-select" >


                                        {row.elective_course.map(course => (

                                            <option value={course.course_id}  >{course.course_name}</option>
                                        ))}

                                    </select>
                                ) : (
                                    <input type="text" className="form-control form-select" value={row.course_name}></input>
                                )
                            )}
                        </div>

                        <div className="col-md-2">
                            <input type="number" className="form-control" id="credit" name="credit" placeholder="Credit" value={row.credit}></input>
                        </div>
                    </div>
                )
            ))}
        </>
    );


    useEffect(() => {
        const { http } = Api();
        setMessage("initial")

        const fetchData = async () => {
            try {

                let college_id= localStorage.getItem("collegeid");
                const response1 = await http.get(`/Admin/getcollege`);
                //const response2 = await http.get(`/Admin/getdiscipline`);
                const response2 = await http.get(`/Admin/getcollegediscipline?college_id=${college_id}`);
                const response3 = await http.get(`/Admin/getpathway`);

                setDisciplineData(response2.data.data);
                setCollegeData(response1.data.data);
                console.log("response2=", response2);
                setPathwayList(response3.data);

            } catch (error) {

                setMessage("somthing went wrong");
                console.error('Error fetching discipline data:', error);

            }
        };

        fetchData();

    }, []);


    const isAuth = useAuth();
    const navigate = useNavigate();
    if (isAuth === false) {
        navigate("/admin/")
    }

    //for tab
    const [activeTab, setActiveTab] = useState('tab1');

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
    };

    return (
        <>
            <ToastContainer />
            <Template>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12" >
                            <div className="card">
                                <div className="col-md-12">
                                    <div className="card-header">
                                        <div className="py-3 d-flex justify-content-between align-items-center ">
                                            <h5>Pathway</h5>
                                        </div>
                                    </div>
                                    <div className="card-body">

                                        <div className="card-body pdg">
                                            <div className="table-responsive">



                                                <div className="card-body custom-input">
                                                    <div className="col">

                                                        <div className="row">
                                                            <div className="row pdg1">

                                                                

                                                                <div className="col-md-6">
                                                                    <label>Discipline</label>
                                                                    

                                                                    <Select
                                                                        id="discipline_id"
                                                                        name="discipline_id"
                                                                        className="form"
                                                                        options={discipline
                                                                            // .sort((a, b) => a.college_name.localeCompare(b.college_name)) // Sort the colleges array alphabetically
                                                                            .map(disciplines => ({
                                                                                value: disciplines.discipline_id,
                                                                                label: disciplines.discipline_name
                                                                            }))}
                                                                        onChange={handleDisciplineChange}
                                                                    />



                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label>Pathway</label>
                                                                    <select className="form-control form-select" id="pathwayid" name="pathwayid" onChange={handleFacultyAndDisciplineChange} required>
                                                                        <option value={0} >Select Pathway</option>
                                                                        {pathwaylist.map(pathway => (

                                                                            <option value={pathway.id}  >{pathway.pathway_name}</option>
                                                                        ))}

                                                                    </select>
                                                                </div>





                                                            </div>
                                                            <br></br>
                                                            <br></br>
                                                            {message ? (
                                                                <div className="alert " style={{ width: '50%', margin: 'auto', marginTop: '20px', textAlign: 'center', fontSize: '20px' }}>Data not available</div>
                                                            ) : (
                                                                <div>
                                                                    <div>
                                                                        <ul className="nav nav-tabs justify-content-center">
                                                                            <li className="nav-item">
                                                                                <a
                                                                                    className={`nav-link ${activeTab === 'tab1' ? 'active selected-tab' : ''}tab-link`}
                                                                                    onClick={() => handleTabClick('tab1')}
                                                                                >
                                                                                    Sem 1
                                                                                </a>
                                                                            </li>
                                                                            <li className="nav-item">
                                                                                <a
                                                                                    className={`nav-link ${activeTab === 'tab2' ? 'active selected-tab' : ''}tab-link`}
                                                                                    onClick={() => handleTabClick('tab2')}

                                                                                >
                                                                                    Sem 2
                                                                                </a>
                                                                            </li>
                                                                            <li className="nav-item">
                                                                                <a
                                                                                    className={`nav-link ${activeTab === 'tab3' ? 'active selected-tab' : ''}tab-link`}
                                                                                    onClick={() => handleTabClick('tab3')}

                                                                                >
                                                                                    Sem 3
                                                                                </a>
                                                                            </li>
                                                                            <li className="nav-item">
                                                                                <a
                                                                                    className={`nav-link ${activeTab === 'tab4' ? 'active selected-tab' : ''}tab-link`}
                                                                                    onClick={() => handleTabClick('tab4')}

                                                                                >
                                                                                    Sem 4
                                                                                </a>
                                                                            </li>
                                                                            <li className="nav-item">
                                                                                <a
                                                                                    className={`nav-link ${activeTab === 'tab5' ? 'active selected-tab' : ''}tab-link`}
                                                                                    onClick={() => handleTabClick('tab5')}

                                                                                >
                                                                                    Sem 5
                                                                                </a>
                                                                            </li>
                                                                            <li className="nav-item">
                                                                                <a
                                                                                    className={`nav-link ${activeTab === 'tab6' ? 'active selected-tab' : ''}tab-link`}
                                                                                    onClick={() => handleTabClick('tab6')}

                                                                                >
                                                                                    Sem 6
                                                                                </a>
                                                                            </li>
                                                                            <li className="nav-item">
                                                                                <a
                                                                                    className={`nav-link ${activeTab === 'tab7' ? 'active selected-tab' : ''}tab-link`}
                                                                                    onClick={() => handleTabClick('tab7')}

                                                                                >
                                                                                    Sem 7
                                                                                </a>
                                                                            </li>
                                                                            <li className="nav-item">
                                                                                <a
                                                                                    className={`nav-link ${activeTab === 'tab8' ? 'active selected-tab' : ''}tab-link`}
                                                                                    onClick={() => handleTabClick('tab8')}

                                                                                >
                                                                                    Sem 8
                                                                                </a>
                                                                            </li>
                                                                        </ul>

                                                                        <div className="bx-hdg">{pathway}</div>


                                                                        <div className="tab-content mt-3" style={{ border: '1px solid #ccc', padding: '30px', backgroundColor: 'rgba(242, 243, 247, 0.7)' }}>
                                                                            <div className={`tab-pane ${activeTab === 'tab1' ? 'active' : ''}`}>
                                                                                <b>SEMESTER 1</b>
                                                                                <Row rows={tabRows.tab1} tab="tab1" />

                                                                            </div>
                                                                            <div className={`tab-pane ${activeTab === 'tab2' ? 'active' : ''}`}>
                                                                                <b>SEMESTER 2</b>
                                                                                <Row rows={tabRows.tab2} tab="tab2" />

                                                                            </div>
                                                                            <div className={`tab-pane ${activeTab === 'tab3' ? 'active' : ''}`}>
                                                                                <b>SEMESTER 3</b>
                                                                                <Row rows={tabRows.tab3} tab="tab3" />

                                                                            </div>
                                                                            <div className={`tab-pane ${activeTab === 'tab4' ? 'active' : ''}`}>
                                                                                <b>SEMESTER 4</b>
                                                                                <Row rows={tabRows.tab4} tab="tab4" />

                                                                            </div>
                                                                            <div className={`tab-pane ${activeTab === 'tab5' ? 'active' : ''}`}>
                                                                                <b>SEMESTER 5</b>
                                                                                <Row rows={tabRows.tab5} tab="tab5" />

                                                                            </div>
                                                                            <div className={`tab-pane ${activeTab === 'tab6' ? 'active' : ''}`}>
                                                                                <b>SEMESTER 6</b>
                                                                                <Row rows={tabRows.tab6} tab="tab6" />

                                                                            </div>
                                                                            <div className={`tab-pane ${activeTab === 'tab7' ? 'active' : ''}`}>
                                                                                <b>SEMESTER 7</b>
                                                                                <Row rows={tabRows.tab7} tab="tab7" />

                                                                            </div>
                                                                            <div className={`tab-pane ${activeTab === 'tab8' ? 'active' : ''}`}>
                                                                                <b>SEMESTER 8</b>
                                                                                <Row rows={tabRows.tab8} tab="tab8" />
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            )}






                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </Template>
        </>
    );
}